var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamInfoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 360,
    viewBox: "0 0 334 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 360
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.944 1.21278C194.673 0.420188 193.206 0 191.709 0H8C3.58172 0 0 3.58172 0 8V352C0 356.418 3.58171 360 7.99999 360H326C330.418 360 334 356.418 334 352V48C334 43.5817 330.418 40 326 40L260.4 40C258.903 40 257.435 39.5798 256.165 38.7872L195.944 1.21278Z",
    fill: "#091415"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 360,
    fill: "#121517"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 334,
    height: 200,
    fill: "url(#paint0_linear_39_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_8",
    x1: 167.514,
    y1: 160,
    x2: 167.514,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19636B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamInfoCard);
export default __webpack_public_path__ + "static/media/team-info-card.d643a6cd1284bbbbaf9b523aa78ffcd3.svg";
export { ForwardRef as ReactComponent };